import axios, { AxiosError } from 'axios';
import { LoginPayloadModel, RegisterPayloadModel, SendLoginOTPPayloadModel, VerifyAccountOTPPayloadModel, CreateDocPayloadModel, updateDocumentFormRequestPayloadModel, UpdateDocumentInfoRequestPayloadModel, ExecutePromptRequestPayloadModel, UpdateDocumentOutlineDataPayloadModel, DeleteDocumentOutlineDataParamsModel, UpdateDocumentTitlePayloadModel, UpdateDocumentEditorPayloadModel, CustomerDetailModel, CreatePersonaPayloadModel, createCustomTemplatePayloadModel, UpdatePersonaPayloadModel, updateCustomerSubscriptionPayloadModel, createChatbotPayloadModel, updateChatbotPayloadModel, addChatbotDomainPayloadModel, updateChatbotDomainPayloadModel, createCampaignPayloadModel, updateCampaignDetailsModel, generateCampaignDocumentPayloadModel, markDefaultPersonaPayloadModel, createUserPopupActionPayload, createChatbotIntegrationPayload, manageChatbotConnectorPayload, updateChatbotFlagInternalPayload, createMetaIntegrationPayload, addChatbotIntegrationPayload, updateTimezonePayload, shareOrganizationInvitationPayload, addChatbotTryNumberPayloadModel, chatbotPersistentPayload, calendlyAuthURLPayloadModel, createAgentsDataPayloadModel, updateCallRecordsPayload, postChatbotCalendlyEventTypeDataPayloadModel, additionalFieldFilters, createLeadGenerationPayloadModel, updateLeadGenerationPayloadModel, manageLeadGenerationPayloadModel, createStaticMessageFormatPayload, reGenerateCallRecord, uploadCartItemsPayload, updateFeedbackPayload, importCallRecordPayload, createCampaignContactListPayload, updateCampaignContactListPayload, updateCampaignContactPayload, importCampaignContactDataPayload, getCampaignContactPayload, deleteContactPayload, createCampaignContactTagPayload, updateCampaignContactTagPayload, createCampaignPayload, createCampaignContactFieldPayload, updateCampaignContactFieldPyload, addFeedbackPayload, callAnalysisFeedbackPayload, updateCallAnalysisFeedbackPayload, runCampaignPayload, updateCampaignPayload, createWhatsappTemplatePayloadNew, createZohoIntegrationOrganizationChatbotAssignmentInterface, createMetaIntegrationPayloadNew, deleteMetaIntegrationPayload, addThreadManualAgent, manualOverrideNewStructurePayloadInterface, createWhatsappTemplatePayload, createChatbotSlackIntegrationPayload, mapParentChatbotWithSubChatbotPayload, createCampaignContactPayload, createWorkflowInterface, addChatbotCustomVariablePayload, updateChatbotCustomVariablePayload, updateChatbotPayload, createDataConnectorAssignementPayload, contactTagActionsPayload, retargetCampaignpayload, syncWhatsappTemplatePayload, CannedResponseTemplate, sendCannedResponsePayload, addContactChatbotAssignmentPayload, sendTemplatePayload, DeploymentTriggerPayload, payloadCreateUpdateWebhook, payloadConfigureWebhook, publishWhatsAppFlowPayload, updateChatbotStatusPayload, listOrdersPayload, grantaccessPayload, resendQrCodePayload, checkPaymentStatuspayload, updateOrganizationNamePayload, createUpdateIntentPayload, completeOnboardingProcessPayload, uploadProductDataFromCSVPayload, createUpdateProductPayload, deleteEComProductsPayload, requestCallbackPayload, reportIssuePayload, updateUserDetail, updateUserPasswordPayload, updateUserOrganizationRolePayload, pauseCampaignPayload, enableCallPayload, askCallPermissionPayload, createVoiceAgentPayload, endCallInterface, initialCallInterface, assignVoiceAgentInterface, assignThreadStatusPayload, addThreadTagPayload, updateThreadTagPayload, assignThreadTagsPayload, asignThreadNotePayload, smartAssistPayload, getRuleBasedInboxThreadsPayload, updateRuleBasedInboxThreadArchiveStatusPayload, createApiKeyPayload, createUserAssignmentRolePayload, updateUserAssignmentRolePayload, createCarouselTemplateGroupPayload, updateCarouselTemplateGroupPayload, createTicketPayload, updateTicketPayload, createTemplateLibraryDraftPayload, archiveCampaignPayload, updateUserStatusPayload, updateDirectSendCannedMsgPayload, enableDisableAgentActivityMsgPayload, createSubStatusPayload, updateSubStatusPayload, toggleSmbAgentAssignmentPayload, createKnowledgeBaseFilesPayload, organizationTeamsData, createOrganizationTeamPayload, updateLeadOrderStatusPayload, syncCatalogPayload, updatePaymentStatusPayload, acceptCallInterface, instagramCommentTriggerPayload, subscribePlanPayload, wabaVerificationRequestPayload, loginWithPasswordPayload, AssignKnowledgeBaseChatbotRequest, purchaseAiCreditsPayload, archiveCampaignContactListPayload, addChatbotCustomVariablesPayload } from '../models/axiosModel';

import { getTime } from 'date-fns';
import { request } from 'http';
import { CreateWhatsappFlowRequest, GetWhatsappFlowParams, UpdateWhatsappFlowRequest } from '../components/dashboard/channels/global/whatsapp/flows/waFlowTypes';
import { postDeploymentTriggerPayload, updateChatbotTriggerConfigs } from '../models/flowBuilderTypes';
import Cookies from 'js-cookie';
import { abortedApiResponse, isRequestAbortedError, trackApiRequest, untrackApiRequest } from './apiRequestLifecycle';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
// axios.defaults.baseURL = "http://192.168.1.2:3000";
const responseBody = (response: any) => {
    if (response?.Title === undefined)
        return response.data
}

const Error = (err: AxiosError) => {
    // @ts-ignore
    if (err?.response !== null && err?.response !== undefined) {
        console.log("response.response.data.error--", err?.response?.data)
    }
    if (err && err.response && err.response.data) {
        return err.response.data;
    }
    return err;
}

const requests = {
    get: async (url: string) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.get(url,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    signal: controller.signal
                });
            untrackApiRequest(url, controller);
            // @ts-ignore
            if (response?.flagStatus === false && response?.error !== "" && response?.error !== null && response?.error !== undefined) {
                alert("Something went wrong.!");
            }
            else {
                return responseBody(response);
            }
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    fileUploadPost: async (url: string, body: any) => {
        try {
            const response = await axios.post(url, body, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            return responseBody(response);
        } catch (err: any) {
            return Error(err);
        }
    },
    post: async (url: string, body: any, onAbort?: () => void) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.post(url, body, {
                headers: {
                    "Content-Type": "application/json"
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                if (onAbort) onAbort();
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    put: async (url: string, body: any) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.put(url, body, {
                headers: {
                    "Content-Type": "application/json"
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    delete: async (url: string) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json"
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    }
};

// Billing Request
const billingBaseURL = process.env.REACT_APP_PAYMENT_URL;

const billingRequests = {
    get: async (url: string) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.get(`${billingBaseURL}/${url}`, {
                headers: {
                    "Content-Type": "application/json",
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            // @ts-ignore
            if (response?.flagStatus === false && response?.error !== "" && response?.error !== null && response?.error !== undefined) {
                alert("Something went wrong.!");
            }
            else {
                return responseBody(response);
            }
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    post: async (url: string, body: any, onAbort?: () => void) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.post(`${billingBaseURL}/${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                if (onAbort) onAbort();
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    put: async (url: string, body: any) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.put(`${billingBaseURL}/${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    },
    delete: async (url: string) => {
        const controller = new AbortController();
        trackApiRequest(url, controller);
        try {
            const response = await axios.delete(`${billingBaseURL}/${url}`, {
                headers: {
                    "Content-Type": "application/json",
                },
                signal: controller.signal
            });
            untrackApiRequest(url, controller);
            return responseBody(response);
        } catch (err: any) {
            untrackApiRequest(url, controller);
            if (isRequestAbortedError(err)) {
                return abortedApiResponse(controller);
            }
            return Error(err);
        }
    }
};

const UserMeAPI = {
    get: () => requests.get("/api/user/get-user-detail"),
    getURL: "/api/user/get-user-detail"
}

const LoaderDetailsAPI = {
    get: () => requests.get(`api/popup/get-image-groups`)
}

const RegisterAPI = {
    post: (payload: RegisterPayloadModel) => requests.post(`/api/user/create-user`, payload)
}
const SendAccountOTPAPI = {
    post: () => requests.post(`/api/user/account-authentication-code`, {})
}
const VerifyAccountOTPAPI = {
    put: (payload: VerifyAccountOTPPayloadModel) => requests.put("api/user/account-authentication-code", payload)
}
const SendLoginOTPAPI = {
    post: (payload: SendLoginOTPPayloadModel) => requests.post("api/user/auth", payload)
}
const VerifyLoginOTPAPI = {
    put: (payload: LoginPayloadModel) => requests.put("api/user/auth", payload)
}

const loginWithPasswordAPI = {
    post: (payload: loginWithPasswordPayload) => requests.post('api/user/login', payload),
}

const LogoutAPI = {
    post: () => requests.post("api/user/logout-user", {})
}
const getUserAdditionalInfo = {
    get: () => requests.get("api/user/get-user-additional-information-data")
}
const getUserAdditionalInfoGenericData = {
    get: () => requests.get("api/user/get-user-additional-information-generic-data")
}
const addUserAdditionalInfo = {
    put: (payload: any) => requests.put("api/user/add-user-additional-information-data", payload)
}
const getTemplateList = {
    get: () => requests.get("api/template/get-template-list")
}
const getTemplateDetail = {
    get: (template_id: number) => requests.get(`api/template/template-detail?template_id=${template_id}`)
}
const createDoc = {
    post: (payload: CreateDocPayloadModel) => requests.post("api/document/create-document", payload)
}
const getDocDetails = {
    get: (document_uuid: String) => requests.get(`api/document/get-document-detail?document_uuid=${document_uuid}`)
}
const getDocList = {
    get: () => requests.get("api/document/get-document-list")
}
const updateDocumentFormSubmissionData = {
    put: (payload: updateDocumentFormRequestPayloadModel) => requests.put("api/document/update-document-form-detail", payload)
}
const updateDocumentInfo = {
    put: (payload: UpdateDocumentInfoRequestPayloadModel) => requests.put("api/document/update-document-info", payload)
}
const getPrompList = {
    get: () => requests.get("api/ai/get-prompt-list")
}
const executePrompt = {
    post: (payload: ExecutePromptRequestPayloadModel, currentTime?: any) => requests.post("api/ai/ask-ai", payload, currentTime),
    getURL: "api/ai/ask-ai"

}
const getDocumentContentTypeData = {
    get: () => requests.get("api/document/get-document-content-type-data")
}

const updateDocumentOutlineData = {
    put: (payload: UpdateDocumentOutlineDataPayloadModel[]) => requests.put("api/document/update-document-outline-detail", payload)
}
const deleteDocument = {
    delete: (document_uuid: string) =>
        requests.delete(`api/document/delete-document?document_uuid=${document_uuid}`)
}
const deleteDocumentOutlineData = {
    delete: (params: DeleteDocumentOutlineDataParamsModel) =>
        requests.delete("api/document/delete-document-outline?" +
            Object.keys(params).map(key => `${key}=${encodeURIComponent((params as any)[key])}`).join('&'))
}
const updateDocumentTitle = {
    put: (payload: UpdateDocumentTitlePayloadModel) => requests.put("api/document/update-document-title", payload)
}
const updateDocumentEditorDetail = {
    put: (payload: UpdateDocumentEditorPayloadModel) => requests.put("api/document/update-document-editor-detail", payload)
}
const contWithGoogle = {
    get: (currentUrl: string, gc_integration_type_id: number) => requests.get(`apiIntegration/api/oauth/outbound/auth-url?currentUrl=${currentUrl}&gc_integration_type_id=${gc_integration_type_id}&chatbot_flag=true`)
}
const getCustomerDetail = {
    get: () => requests.get("api/stripe/get-stripe-customer-detail")
}
const updateCustomerDetail = {
    put: (payload: CustomerDetailModel) => requests.put("api/stripe/update-stripe-customer-detail", payload)
}
const getPricingDetail = {
    get: () => requests.get("api/stripe/get-stripe-pricing-detail")

}
const getStripeCustomerSubscriptionDetail = {
    get: () => requests.get("api/stripe/get-stripe-customer-subscription-detail")
}
const getStripeCustomerPortalLink = {
    get: () => requests.get("api/stripe/get-stripe-customer-portal-link")
}
// persona
const getPersonaList = {
    get: () => requests.get("api/persona/get-persona-list")
}
const getSystemPersonaPublicList = {
    get: () => requests.get("api/persona/get-system-persona-list")
}
const getPersonaDetails = {
    get: (persona_id: number) => requests.get(`api/persona/get-persona-deatils?persona_id=${persona_id}`)
}
const createNewPersona = {
    post: (payload: CreatePersonaPayloadModel) => requests.post("api/persona/create-persona", payload)
}
const updatePersona = {
    put: (payload: UpdatePersonaPayloadModel) => requests.put("api/persona/update-persona-details", payload)
}
const markDefaultPersona = {
    put: (payload: markDefaultPersonaPayloadModel) => requests.put("api/persona/set-default-persona", payload)
}
const removeDefaultPersona = {
    delete: (default_persona_type_id: string, persona_id: string) => requests.delete(`api/persona/remove-default-persona?default_persona_type_id=${default_persona_type_id}&persona_id=${persona_id}`)
}
const getDefaultPersonaTypeList = {
    get: () => requests.get("api/persona/get-default-persona-type-list")
}
const deletePersona = {
    delete: (persona_id: string) =>
        requests.delete(`api/persona/delete-persona?persona_id=${persona_id}`)
}
const getPersonaWritingSkillsDetails = {
    get: () => requests.get("api/persona/get-writing-skills-details")
}
const getReadingSkillsDetails = {
    get: () => requests.get("api/persona/get-reading-skills-details")
}
const getSentenceLengthDetails = {
    get: () => requests.get("api/persona/get-sentence-length-details")
}
const getNarrativeTypeDetails = {
    get: () => requests.get("api/persona/get-narrative-type-details")
}
const getCommunicationTypeDetails = {
    get: () => requests.get("api/persona/get-communication-type-details")
}
const oneTapLoginAuthCallback = {
    post: (payload: any) => requests.post("api/user/auth/callback", payload)
}
const getBannerData = {
    get: () => requests.get("api/banner/get-banner")
}
const fileUpload = {
    post: (payload: any) => requests.fileUploadPost("api/storage/upload-file", payload)
}
const createCustomTemplate = {
    post: (payload: createCustomTemplatePayloadModel) => requests.post("api/template/create-custom-template", payload)
}
const updateCustomTemplate = {
    put: (payload: createCustomTemplatePayloadModel) => requests.put("api/template/update-custom-template", payload)
}
const deleteCustomTemplate = {
    delete: (template_id: string) => requests.delete(`api/template/delete-custom-template?template_id=${template_id}`)
}
// Chatbot
const createChatbot = {
    post: (payload: createChatbotPayloadModel) => requests.post("api/chatbot", payload)
}
const getChatbotList = {
    get: () => requests.get("api/chatbot/chatbot-list")
}
const getChatbotData = {
    get: (id: number) => requests.get("api/chatbot?chatbot_id=" + id)
}
const getFileDetail = {
    get: (id: number | string) => requests.get("api/storage/file?file_id=" + id + "&flag_info=true")
}
const uploadFile = {
    post: (formData: FormData, config?: any) => axios.post("api/storage/file", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
        onUploadProgress: config?.onUploadProgress,
    })
}
const batchImportCallAnalysis = {
    post: (formData: FormData) => axios.post("api/call-analysis/batch-import", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
    })
}
const removeUploadedFile = {
    delete: (fileId: any) => axios.delete(`api/storage/file?file_id=${fileId}`, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
    })
}
const updateChatbotData = {
    put: (payload: updateChatbotPayloadModel) => requests.put("api/chatbot", payload)
}
const addChatbotDomain = {
    post: (payload: addChatbotDomainPayloadModel) => requests.post("api/chatbot/chatbot-domain", payload)
}
const updateChatbotDomain = {
    put: (payload: updateChatbotDomainPayloadModel) => requests.put("api/chatbot/chatbot-domain", payload)
}
const deleteChatbotDomain = {
    // delete: (chatbot_domain_id: number, chatbot_id: string) => requests.delete(`api/chatbot/chatbot-domain?chatbot_domain_id=${chatbot_domain_id}&chatbot_id=${chatbot_id}`)
    delete: (website_integration_channel_id: number, chatbot_id: string) => requests.delete(`api/chatbot/chatbot-domain?website_integration_channel_id=${website_integration_channel_id}&chatbot_id=${chatbot_id}`)
}
const cancelStripeSubscription = {
    delete: (gc_stripe_customer_subscription_id: number) => requests.delete(`api/stripe/cancel-stripe-subscription?gc_stripe_customer_subscription_id=${gc_stripe_customer_subscription_id}`)
}
const UpdateStripeSubscription = {
    put: (payload: updateCustomerSubscriptionPayloadModel) => requests.put(`api/stripe/create-change-stripe-plan-customer-subscription`, payload)
}

const removeChatbot = {
    delete: (chatbot_id: any) => requests.delete(`api/chatbot?chatbot_id=${chatbot_id}`)
}


// Campaign
const getCampaignList = { get: () => requests.get("api/campaign/get-campaign-list") }

const createCampaignList = {
    post: (payload: createCampaignPayloadModel) => requests.post(`api/campaign/create-campaign`, payload)
}

const getCampaignDetails = {
    get: (campaign_id: string) => requests.get(`api/campaign/get-campaign-details?campaign_id=${campaign_id}`)
}

const updateCampaignDetails = {
    put: (payload: updateCampaignDetailsModel) => requests.put(`api/campaign/update-campaign-details`, payload)
}

const removeCampaign = {
    delete: (campaign_id: any) => requests.delete(`api/campaign/remove-campaign?campaign_id=${campaign_id}`)
}

const getTemplateCampaignList = { get: () => requests.get("api/campaign/get-campaign-template-list") }

const generateCampaignDocument = {
    post: (payload: generateCampaignDocumentPayloadModel) => requests.post(`api/campaign/generate-campaign-document`, payload)
}

const getCampaignDocuemnts = { get: (campaign_id: string) => requests.get(`api/campaign/get-campaign-document?campaign_id=${campaign_id}`) }

const getRewriteToneGenericList = {
    get: () => requests.get(`api/global/get-rewrite-tone-list`)
}
const getWorkDomainList = {
    get: () => requests.get(`api/global/get-work-domain-list`)
}
const getLanguageList = {
    get: () => requests.get("api/global/languages")
}
const getRouteSourceIds = {
    get: () => requests.get("api/global/get-route-source-list")
}
const getOutputFormatGenericList = {
    get: () => requests.get("api/global/get-output-format-generic-list"),
    getURL: "api/global/get-output-format-generic-list"

}
const getStripeCurrencyTypeGenericList = {
    get: () => requests.get("api/stripe/get-stripe-currency-type-generic-list")
}
const getPromptLogFieldsGenericList = {
    get: () => requests.get("api/dev_portal/prompt-log-field")
}
const getDialectList = {
    get: () => requests.get("api/dev_portal/dialect")
}
const getPopupList = {
    get: () => requests.get("api/popup/get-module-data-list")
}
const createUserPopupAction = {
    post: (payload: createUserPopupActionPayload) => requests.post("/api/popup/change-user-popup-action", payload)
}
const resetChatbotSession = {
    get: () => requests.get("api/chatbot/reset-chat")
}
const removeFile = {
    delete: (file_id: any) => requests.delete(`api/storage/file?file_id=${file_id}`)
}
// meta
const getMetaCredentials = {
    get: () => requests.get("api/chatbot/get-meta-credential")
}
const createChatbotIntegration = {
    post: (payload: createChatbotIntegrationPayload) => requests.post("api/chatbot/integration", payload)
}
const getChatbotIntegrationData = {
    get: (chatbot_id: string, meta_integration_id: string) => requests.get(`api/chatbot/integration?chatbot_id=${chatbot_id}&meta_integration_id=${meta_integration_id}`)
}
const deleteChatbotIntegration = {
    // , meta_integration_id: string
    // &meta_integration_id=${meta_integration_id}
    delete: (chatbot_id: string) => requests.delete(`api/chatbot/integration?chatbot_id=${chatbot_id}`)
}
const getChatbotThreadsList = {
    get: (chatbot_id: string) => requests.get(`api/chatbot/get-chatbot-threads-list?chatbot_id=${chatbot_id}`)
}
const getChatbotThreadDetails = {
    get: (chatbot_id: string, chatbot_user_id: string) => requests.get(`api/chatbot/get-chatbot-thread-details?chatbot_id=${chatbot_id}&chatbot_user_id=${chatbot_user_id}`)
}
const getCountryCode = {
    get: () => requests.get("'https://ipinfo.io?token")
}
const getChatLogs = {
    get: (chatbot_flag_message_feedback: boolean, page_number: Number, records_per_page: Number, chatbot_id?: Number) => requests.get(`api/chatbot/get-user-chats?chatbot_flag_message_feedback=${chatbot_flag_message_feedback}&page_number=${page_number}&records_per_page=${records_per_page}&chatbot_id=${chatbot_id}`)
}
const getAllChatLogs = {
    get: (chatbot_flag_message_feedback: boolean, page_number: Number, records_per_page: Number) => requests.get(`api/chatbot/get-user-chats?chatbot_flag_message_feedback=${chatbot_flag_message_feedback}&page_number=${page_number}&records_per_page=${records_per_page}`)
}
const getChatThreadData = {
    get: (chatbot_user_id: number | string) => requests.get(`api/chatbot/get-user-chats?chatbot_user_id=${chatbot_user_id}`)
}
// const getChatbotDataConnectorList = {
//     get: (chatbot_id: string) => requests.get(`api/chatbot/data-connector-list?chatbot_id=${chatbot_id}`)
// } 

const getChatbotDataConnectorList = {
    get: (
        data_connector_assignment_type_id?: string,
        data_connector_assignment_unique_id?: string
    ) => {
        const params = new URLSearchParams();
        if (data_connector_assignment_type_id) params.append('data_connector_assignment_type_id', data_connector_assignment_type_id);
        if (data_connector_assignment_unique_id) params.append('data_connector_assignment_unique_id', data_connector_assignment_unique_id);

        return requests.get(`api/data-connector?${params.toString()}`)
    }
}

const getDataConnectorAssignmentType = {
    get: () => requests.get(`api/global/data-connector-assignment-type`)
}

const createDataConnectorAssignment = {
    post: (payload: createDataConnectorAssignementPayload) => requests.post(`api/data-connector/assignment`, payload)
}

const deleteDataConnectorAssignment = {
    delete: (data_connector_assignment_id: number) => requests.delete(`api/data-connector/assignment?data_connector_assignment_id=${data_connector_assignment_id}`)
}

// const manageChatbotDataConnector = {
//     post: (payload: any) => requests.post('api/chatbot/v2/data-connector', payload)
// }

const manageDataConnector = {
    post: (payload: any) => requests.post(`api/data-connector`, payload)
}

const manageDataConnectorPlatformList = {
    get: () => requests.get("api/global/data-connector-platform")
}
// const deleteChatbotDataConnector = {
//     delete: (chatbot_data_connector_id: string, chatbot_id: string) => requests.delete(`api/chatbot/data-connector?chatbot_data_connector_id=${chatbot_data_connector_id}&chatbot_id=${chatbot_id}`)
// }

const deleteDataConnector = {
    delete: (chatbot_data_connector_id: string) => requests.delete(`api/data-connector?chatbot_data_connector_id=${chatbot_data_connector_id}`)
}

// const getChatbotDataConnectorDetail = {
//     get: (chatbot_data_connector_id: string, chatbot_id: string) => requests.get(`api/chatbot/data-connector-detail?chatbot_data_connector_id=${chatbot_data_connector_id}&chatbot_id=${chatbot_id}`)
// }

const getDataConnectorDetail = {
    get: (chatbot_data_connector_id: number) => requests.get(`api/data-connector/detail?chatbot_data_connector_id=${chatbot_data_connector_id}`)
}

const getFunctionMethods = {
    get: () => requests.get('api/global/function-methods')
}
const getFunctionParameterTypeData = {
    get: () => requests.get('api/global/function-parameter-type')
}
const updateFlagInternal = {
    put: (payload: updateChatbotFlagInternalPayload) => requests.put('api/dev_portal/update-chatbot-flag-internal', payload)
}
// new integration calls for global integration
const getMetaIntegration = {
    get: (meta_integration_id: string, flag_cancel_meta_integration_sync?: boolean) => requests.get(`api/meta-integration?meta_integration_id=${meta_integration_id}&flag_cancel_meta_integration_sync=${flag_cancel_meta_integration_sync}`)
    // get: (channel_authoriser_user_data_id: number | null) => requests.get(`api/meta-integration?channel_authoriser_user_data_id=${channel_authoriser_user_data_id}`)
}
const createMetaIntegration = {
    // post: (payload: createMetaIntegrationPayload) => requests.post('api/meta-integration', payload)
    post: (payload: createMetaIntegrationPayloadNew) => requests.post('api/meta-integration', payload)
}
const deleteMetaIntegration = {
    delete: (deleteMetaIntegrationPayload: deleteMetaIntegrationPayload) => requests.delete(`api/meta-integration?channel_id=${deleteMetaIntegrationPayload.channel_id}` + (deleteMetaIntegrationPayload.integrated_channel_id ? (`&integrated_channel_id=${deleteMetaIntegrationPayload.integrated_channel_id}`) : (`&meta_integration_whatsapp_id=${deleteMetaIntegrationPayload.meta_integration_whatsapp_id}`)))
}
// const getMetaIntegrationType = {
//     get: () => requests.get('api/global/meta-integration-type')
// } 
const syncWhatsappTemplate = {
    post: (payload: syncWhatsappTemplatePayload) => requests.post('api/meta-integration/sync-whatsapp-template', payload)
}

const getChannelList = {
    get: () => requests.get(`api/global/channel`)
}

const getWhatsappTemplateButtonType = {
    get: () => requests.get('api/global/whatsapp-template-button-type')
}
const createWhatsappTemplate = {
    post: (payload: any) => requests.post('api/meta-integration/create-whatsapp-template', payload)
}
const getWhatsappTemplateList = {
    get: (meta_integration_whatsapp_id: number, whatsapp_template_type_id?: number, whatsapp_template_button_type_id?: number, flag_interactive?: boolean) => {
        const params = new URLSearchParams();
        if (whatsapp_template_type_id) params.append('whatsapp_template_type_id', String(whatsapp_template_type_id));
        if (whatsapp_template_button_type_id) params.append('whatsapp_template_button_type_id', String(whatsapp_template_button_type_id));
        if (flag_interactive) params.append('flag_interactive', String(flag_interactive));

        return requests.get(`/api/meta-integration/${meta_integration_whatsapp_id}/whatsapp-template/whatsapp_template_id?${params.toString()}`)
    }
}
const getWhatsappTemplateDetails = {
    get: (meta_integration_whatsapp_id: number, whatsapp_template_id: number) => requests.get(`api/meta-integration/${meta_integration_whatsapp_id}/whatsapp-template/${whatsapp_template_id}`)
}
const updateWhatsappTemplate = {
    put: (payload: createWhatsappTemplatePayload) => requests.put('api/meta-integration/update-whatsapp-template', payload)
}
const whatsappTemplateDynamicVariableType = {
    get: () => requests.get('api/global/whatsapp-template-dynamic-variable-type')
}
const whatsappTemplateHeaderType = {
    get: () => requests.get('api/global/whatsapp-template-header-type')
}
const whatsappTemplateFooterType = {
    get: () => requests.get('api/global/whatsapp-template-footer-type')
}
const createWhatsappTemplateNew = {
    post: (payload: createWhatsappTemplatePayloadNew) => requests.post('api/create-whatsapp-template', payload)
}
const getWhatsappTemplateType = {
    get: () => requests.get('api/global/whatsapp-template-type')
}
const addChatbotIntegration = {
    post: (payload: addChatbotIntegrationPayload) => requests.post(`api/chatbot/integration`, payload)
}
const removeChatbotIntegration = {
    delete: (channel_id: string, chatbot_id: string, integrated_channel_id: string) => requests.delete(`api/chatbot/integration?channel_id=${channel_id}&chatbot_id=${chatbot_id}&integrated_channel_id=${integrated_channel_id}`)
    // delete: (chatbot_id: string, meta_integration_id: string, meta_integration_type_id: string, phone_number_id: string) => requests.delete(`api/chatbot/integration?chatbot_id=${chatbot_id}&meta_integration_id=${meta_integration_id}&&meta_integration_type_id=${meta_integration_type_id}&phone_number_id=${phone_number_id}`)
}
const getGenericTimezone = {
    get: () => requests.get('api/global/timezone')
}
const updateUserTimezone = {
    put: (payload: updateTimezonePayload) => requests.put(`api/user/update-timezone`, payload)
}
const shareOrganizationInvitation = {
    post: (payload: shareOrganizationInvitationPayload) => requests.post('api/organization/share-invitation', payload)
}
const acceptOrganizationInvitation = {
    get: (organization_invitation_token: string) => requests.get(`api/organization/accept-invitation?organization_invitation_token=${organization_invitation_token}`)
}
const removeUserFromOrganization = {
    delete: (email_address: string) => requests.delete(`api/organization/remove-user?email_address=${email_address}`)
}

const updateUserOrganizationRole = {
    put: (payload: updateUserOrganizationRolePayload) => requests.put(`api/organization/update-user-organization-role`, payload),
}

const getOrganizationDetails = {
    get: () => requests.get('api/organization/details')
}
const removeDelegateAccess = {
    delete: () => requests.delete(`api/dev_portal/delegate-access`)
}

//test numbers
const whatsappTryNowNumbers = {
    get: () => requests.get('api/whatsapp-try-now/get-whatsapp-try-now-phone-number')
}

const addTryNowPhoneNumbers = {
    post: (payload: addChatbotTryNumberPayloadModel) => requests.post('api/whatsapp-try-now/add-chatbot-try-now-phone-numbers', payload)
}

const getChatbotTryNowPhoneNumbers = {
    get: (chatbot_id: number) => requests.get(`api/whatsapp-try-now/get-chatbot-try-now-phone-numbers?chatbot_id=${chatbot_id}`)
}

const submitFeedback = {
    post: (data: any) => requests.post(`/api/feedback/chatbot-thread?chatbot_token=${data.token}`, data.payload)
}
const getFile = {
    get: (id: number) => requests.get("api/storage/file?file_id=" + id + "&flag_info=false")
}
const createPersistentMenuAPI = {
    post: (payload: any) => requests.post('api/chatbot/persistent-menu', payload)
}
const updatePersistentMenuAPI = {
    put: (payload: any) => requests.put('api/chatbot/persistent-menu', payload)
}
const removePersistentMenuDataAPI = {
    delete: (chatbot_persistent_menu_id: any) => requests.delete(`api/chatbot/persistent-menu?chatbot_persistent_menu_id=${chatbot_persistent_menu_id}`)
}
const getPlaygroundURl = {
    get: (thread_id: string) => requests.get(`api/global/get-openai-thread?thread_id=${thread_id}`)
}
const getCallCategory = {
    get: () => requests.get("api/call-analysis/get-call-category")
}
const getCallComplexity = {
    get: () => requests.get("api/call-analysis/get-call-complexity")
}
const getCallEvaluationParameter = {
    get: () => requests.get("api/call-analysis/get-call-evaluation-parameter")
}
const getCallAgent = {
    get: () => requests.get("api/call-analysis/get-call-agent")
}
const getCallParentCategory = {
    get: () => requests.get("api/call-analysis/get-call-parent-category")
}
const updateCallRecords = {
    put: (payload: updateCallRecordsPayload) => requests.put(`api/call-analysis/update-call-record`, payload)
}
const regenerateCallRecord = {
    put: (payload: reGenerateCallRecord) => requests.put('api/call-analysis/regenerate-call-analysis', payload)
}
const importCallRecord = {
    post: (payload: importCallRecordPayload) => requests.post('api/call-analysis/batch-import', payload)
}
// const getCallRecords = {
//     get: () => requests.get("api/call-analysis/get-call-records")
// }
const getCallRecords = {
    get: (
        start_date?: string | null,
        end_date?: string | null,
        phone_number?: string | null,
        extension?: string | null,
        call_parent_category_id?: number | null,
        call_category_id?: number | null,
        call_complexity_id?: number | null,
        agent_id?: number | null,
        call_record_additional_field?: additionalFieldFilters[] | null,
        flag_alert?: boolean | null,
        flag_dashboard_analysis?: boolean | null,
        flag_score_in_asc?: boolean | null
    ) => {

        const params = new URLSearchParams();

        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (phone_number) params.append('phone_number', phone_number);
        if (extension) params.append('extension', extension);
        if (call_parent_category_id !== null && call_parent_category_id !== undefined) params.append('call_parent_category_id', call_parent_category_id?.toString());
        if (call_category_id !== null && call_category_id !== undefined) params.append('call_category_id', call_category_id.toString());
        if (call_complexity_id !== null && call_complexity_id !== undefined) params.append('call_complexity_id', call_complexity_id.toString());
        if (agent_id !== null && agent_id !== undefined) params.append('agent_id', agent_id.toString());
        if (call_record_additional_field && call_record_additional_field.length > 0) {
            params.append('call_record_additional_field', JSON.stringify(call_record_additional_field));
        }
        if (flag_alert !== null && flag_alert !== undefined) {
            params.append('flag_alert', flag_alert ? "true" : "false");
        }
        if (flag_dashboard_analysis !== null && flag_dashboard_analysis !== undefined) {
            params.append('flag_dashboard_analysis', flag_dashboard_analysis ? "true" : "false");
        }
        if (flag_score_in_asc !== null && flag_score_in_asc !== undefined) {
            params.append('flag_score_in_asc', flag_score_in_asc ? "true" : "false");
        }

        return requests.get(`api/call-analysis/get-call-records?${params.toString()}`);
    }
}
const getCallEvaluationScoreColor = {
    get: () => requests.get("api/call-analysis/get-call-evaluation-score-and-color")
}

const getPhoneNumbersList = {
    get: () => requests.get("api/call-analysis/get-phone-numbers")
}
const getExtensionsList = {
    get: () => requests.get("api/call-analysis/get-extensions")
}
const getCallRecordDetails = {
    get: (call_record_id: number) => requests.get(`api/call-analysis/get-call-record-detail?call_record_id=${call_record_id}`)
}
const getCallAnalysisAdditionalField = {
    get: () => requests.get("api/call-analysis/get-call-analysis-additional-field")
}
const getCallAnalysisFeedbackType = {
    get: () => requests.get("api/feedback/call-analysis-feedback-type")
}
const getCallAnalysisOption = {
    get: () => requests.get("api/feedback/call-analysis-option")
}
const getCallAnalysisFeedback = {
    get: (
        feedback_status_id?: number | null,
        modification_status_id?: number | null,
        start_date?: string | null,
        end_date?: string | null,
        user_id?: string | null,
    ) => {
        const params = new URLSearchParams();
        if (feedback_status_id) params.append('feedback_status_id', feedback_status_id.toString());
        if (modification_status_id) params.append('modification_status_id', modification_status_id.toString());
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (user_id) params.append('user_id', user_id);

        return requests.get(`api/feedback/call-analysis-feedback?${params.toString()}`);
    }
}
const createCallAnalysisFeedback = {
    post: (payload: callAnalysisFeedbackPayload) => requests.post('api/feedback/call-analysis-feedback', payload)
}
const updateCallAnalysisFeedback = {
    put: (payload: updateCallAnalysisFeedbackPayload) => requests.put('api/feedback/call-analysis-feedback', payload)
}
const createAgentAPI = {
    post: (payload: createAgentsDataPayloadModel) => requests.post('api/call-analysis/create-agent', payload)
}
const resetChatbotThreadByAdmin = {
    get: (chatbot_id: string, thread_id: string) => requests.get(`api/chatbot/reset-chatbot-user-thread?chatbot_id=${chatbot_id}&thread_id=${thread_id}`)
}

const closeStaticWorkflowThread = {
    post: (thread_id: string) => requests.post(`api/thread/close-conversation/${thread_id}`, {}),
}

const calendlyAuthUrlApi = {
    post: (payload: calendlyAuthURLPayloadModel) => requests.post('api/oauth/get-auth-url', payload)
}

const getCallbackStatus = {
    get: (state: string) => requests.get(`api/oauth/get-callback-status?state=${state}`)
}

const getCalendlyIntegrationData = {
    get: (calendly_integration_id?: string) => {
        const params = new URLSearchParams();
        if (calendly_integration_id) {
            params.append('calendly_integration_id', calendly_integration_id)
        }
        return requests.get(`api/scheduling-tool/calendly?${params.toString()}`);
    }
}

const postChatbotCalendlyEventTypeData = {
    post: (payload: postChatbotCalendlyEventTypeDataPayloadModel) => requests.post('api/chatbot/calendly', payload)
}

const deleteChatbotCalendlyIntegration = {
    delete: (calendly_integration_id: string, chatbot_id: string) => requests.delete(`api/chatbot/calendly?calendly_integration_id=${calendly_integration_id}&chatbot_id=${chatbot_id}`)
}

const getCustomPages = {
    get: () => requests.get('api/pages/get-pages')
}

const getGenericFieldTypeData = {
    get: () => requests.get('api/global/field-type')
}

const getLeadIntegrationTypeData = {
    get: () => requests.get('api/global/lead-integration-type')
}

const createLeadGeneration = {
    post: (payload: createLeadGenerationPayloadModel) => requests.post('api/lead/create', payload)
}

const updateLeadGeneration = {
    put: (payload: updateLeadGenerationPayloadModel) => requests.put('api/lead/update', payload)
}

const getLeadGenerationData = {
    get: (
        chatbot_id: string,
        chatbot_lead_id?: string | null
    ) => {
        const params = new URLSearchParams();
        params.append('chatbot_id', chatbot_id)
        if (chatbot_lead_id) params.append('chatbot_lead_id', chatbot_lead_id);

        return requests.get(`api/lead/view?${params.toString()}`);
    }
}

const deleteLeadGeneration = {
    delete: (chatbot_id: string, chatbot_lead_id: string) => requests.delete(`api/lead/delete?chatbot_id=${chatbot_id}&chatbot_lead_id=${chatbot_lead_id}`)
}

const manageLeadGeneration = {
    post: (payload: manageLeadGenerationPayloadModel) => requests.post('api/lead/integration', payload)
}

const deleteLeadIntegration = {
    delete: (chatbot_id: string, chatbot_lead_id: string, chatbot_lead_integration_id: string) => requests.delete(`api/lead/integration?chatbot_id=${chatbot_id}&chatbot_lead_id=${chatbot_lead_id}&chatbot_lead_integration_id=${chatbot_lead_integration_id}`)
}

const getIntegrations = {
    get: () => requests.get('api/global/get-integration-app')
}
const getSlackintegrations = {
    get: () => requests.get(`api/chatbot/slack`)
}
const createChatbotSlackIntegration = {
    post: (payload: createChatbotSlackIntegrationPayload) => requests.post('api/chatbot/slack', payload)
}
const deleteChatbotSlackIntegration = {
    delete: (chatbot_slack_assignment_id: string) => requests.delete(`api/chatbot/slack-assignment?chatbot_slack_assignment_id=${chatbot_slack_assignment_id}`)
}
const deleteSlackIntegration = {
    delete: (slack_integration_id: number) => requests.delete(`api/chatbot/slack-integration?slack_integration_id=${slack_integration_id}`)
}
const handleToggleManualOverride = {
    put: (thread_id: any) => requests.put('api/chatbot/switch-chatbot-thread-mode', thread_id)
}

const getStaticMessageFormat = {
    get: (chatbot_id: any) => requests.get(`api/message-format/static?chatbot_id=${chatbot_id}`)
}
const createStaticMessageFormat = {
    post: (payload: createStaticMessageFormatPayload) => requests.post('api/message-format/static', payload)
}
const updateStaticMessageFormat = {
    put: (payload: createStaticMessageFormatPayload) => requests.put('api/message-format/static', payload)
}
const deleteStaticMessageFormat = {
    delete: (chatbot_id: string, chatbot_static_message_id: string) => requests.delete(`api/message-format/static?chatbot_id=${chatbot_id}&chatbot_static_message_id=${chatbot_static_message_id}`)
}
const getProductListData = {
    get: (chatbot_id: string) => requests.get(`api/ecom/cart-item?chatbot_id=${chatbot_id}`)
}
const getFeedbackProvidedType = {
    get: () => requests.get(`api/global/get-feedback-provided-type`)
}
const getFeedbackLevel = {
    get: () => requests.get(`api/feedback/level`)
}
const getListOfFeedbackOption = {
    get: (chatbot_id: string, chatbot_token: string) => requests.get(`api/feedback/option?chatbot_id=${chatbot_id}&chatbot_token=${chatbot_token}`)
}
const addFeedback = {
    post: (payload: addFeedbackPayload, chatbot_token: string) => requests.post(`api/feedback?chatbot_token=${chatbot_token}`, payload)
}
const getFeedbackStatus = {
    get: () => requests.get(`api/global/get-feedback-status`)
}
const getFeedbackModificationStatus = {
    get: () => requests.get(`api/global/get-modification-status`)
}
const getFeedback = {
    get: (
        feedback_status_id?: number | null,
        modification_status_id?: number | null,
        start_date?: string | null,
        end_date?: string | null,
        user_id?: string | null,
    ) => {
        const params = new URLSearchParams();
        if (feedback_status_id) params.append('feedback_status_id', feedback_status_id.toString());
        if (modification_status_id) params.append('modification_status_id', modification_status_id.toString());
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (user_id) params.append('user_id', user_id);

        return requests.get(`api/feedback?${params.toString()}`);
    }
}

const updateFeedback = {
    put: (payload: updateFeedbackPayload) => requests.put(`api/feedback`, payload)
}
const uploadCartItems = {
    post: (payload: uploadCartItemsPayload) => requests.post(`api/ecom/upload-cart-item`, payload)
}

const getCampaignContactList = {
    get: () => requests.get(`api/contact/list`)
}

const createCampaignContactList = {
    post: (payload: createCampaignContactListPayload) => requests.post(`api/contact/list`, payload)
}

const updateCampaignContactList = {
    put: (payload: updateCampaignContactListPayload) => requests.put(`api/contact/list`, payload)
}

const archiveContactList = {
    put: (payload: archiveCampaignContactListPayload) => requests.put(`api/contact/list/status`, payload)
}

const deleteContactList = {
    delete: (contact_list_id: number) => requests.delete(`api/contact/list?contact_list_id=${contact_list_id}`)
}

const getCampaignContact = {
    post: (payload: getCampaignContactPayload) => requests.post(`api/contact`, payload)
}

const updateCampaignContact = {
    put: (payload: updateCampaignContactPayload) => requests.put(`api/contact`, payload)
}

const deleteCampaignContact = {
    put: (payload: deleteContactPayload) => requests.put(`api/contact/delete-contact`, payload),
}

const createCampaignContact = {
    post: (payload: createCampaignContactPayload) => requests.post(`api/contact/create-contact`, payload),
}

const importCampaignContactData = {
    post: (payload: importCampaignContactDataPayload) => requests.post(`api/contact/import-contact-data`, payload)
}

const getListOfCampaignContactField = {
    get: (contact_list_id: number) => requests.get(`api/contact/field?contact_list_id=${contact_list_id}`)
}

const createCampaignContactField = {
    post: (payload: createCampaignContactFieldPayload) => requests.post(`api/contact/field`, payload)
}

const updateCampaignContactField = {
    put: (payload: updateCampaignContactFieldPyload) => requests.put(`api/contact/field`, payload)
}

const deleteCampaignContactField = {
    delete: (contact_field_id: number) => requests.delete(`api/contact/field?contact_field_id=${contact_field_id}`)
}

const getListOfCampaignFieldType = {
    get: () => requests.get(`api/global/contact-field-type`)
}

const getListOfCampaignContactTag = {
    get: (contact_list_id: number) => requests.get(`api/contact/tag?contact_list_id=${contact_list_id}`),
}

const createCampaignContactTag = {
    post: (payload: createCampaignContactTagPayload) => requests.post(`api/contact/tag`, payload),
}

const updateCampaignContactTag = {
    put: (payload: updateCampaignContactTagPayload) => requests.put(`api/contact/tag`, payload),
}

const deleteCampaignContactTag = {
    delete: (contact_tag_id: number) => requests.delete(`api/contact/tag?contact_tag_id=${contact_tag_id}`),
}

const createCampaign = {
    post: (payload: createCampaignPayload | retargetCampaignpayload) => requests.post(`api/campaign`, payload),
}

const updateCampaign = {
    put: (payload: updateCampaignPayload) => requests.put(`api/campaign`, payload),
}

const getCampaignData = {
    get: (campaign_id?: number | null) => {
        const params = new URLSearchParams();
        if (campaign_id) params.append('campaign_id', campaign_id.toString());
        return requests.get(`api/campaign?${params.toString()}`);
    }
}

const getMultipleCampaignData = {
    get: (campaign_ids: string | null, start_date: string | null, end_date: string | null) => {
        const params = new URLSearchParams();
        if (campaign_ids) params.append("campaign_ids", campaign_ids)
        if (start_date) params.append("start_date", start_date);
        if (end_date) params.append("end_date", end_date);
        return requests.get(`api/campaign/multiple-campaign?${params.toString()}`);
    }
}

const getCampaignMessageType = {
    get: () => requests.get(`api/global/campaign-message-type`),
}

const getCampaignContactFilterType = {
    get: () => requests.get(`api/global/campaign-contact-filter-type`),
}

const getCampaignExecutionStatus = {
    get: () => requests.get(`api/global/campaign-execution-status`),
}

const runCampaign = {
    post: (payload: runCampaignPayload) => requests.post(`api/campaign/run-campaign`, payload),
}

const resumeCampaign = {
    post: (payload: runCampaignPayload) => requests.post(`api/campaign/resume-campaign`, payload),
}

const archiveCampaign = {
    post: (payload: archiveCampaignPayload) => requests.post(`api/campaign/archive-campaign`, payload),
}

const pauseCampaign = {
    post: (payload: pauseCampaignPayload) => requests.post(`api/campaign/pause-campaign`, payload),
}

const deleteCampaign = {
    delete: (campaign_id: number) => requests.delete(`api/campaign?campaign_id=${campaign_id}`),
}

const createZohoIntegrationOrganizationChatbotAssignment = {
    post: (payload: createZohoIntegrationOrganizationChatbotAssignmentInterface) => requests.post('api/zoho/chatbot-assignment', payload)
}

const deleteZohoIntegrationChatbotAssignment = {
    delete: (zoho_integration_organization_chatbot_id: number) => requests.delete(`api/zoho/chatbot-assignment?zoho_integration_organization_chatbot_id=${zoho_integration_organization_chatbot_id}`)
}

const getZohoIntegration = {
    get: () => requests.get('api/zoho/integration')
}

const getZohoTicketFields = {
    get: (zoho_integration_id: number | null) => requests.get(`api/zoho/ticket-field?zoho_integration_id=${zoho_integration_id}`)
}

const getListOfZohoContact = {
    get: (zoho_integration_organization_id: number) => requests.get(`api/zoho/contact?zoho_integration_organization_id=${zoho_integration_organization_id}`)
}

const getListOfZohoDepartment = {
    get: (zoho_integration_organization_id: number) => requests.get(`api/zoho/department?zoho_integration_organization_id=${zoho_integration_organization_id}`)
}

const deleteZohoIntegration = {
    delete: (zoho_integration_id: string, zoho_integration_organization_id: number) => requests.delete(`api/zoho/integration?zoho_integration_id=${zoho_integration_id}&zoho_integration_organization_id=${zoho_integration_organization_id}`)
}

const getZohoTicketLogs = {
    get: (zoho_integration_id: number) => requests.get(`api/zoho/ticket?zoho_integration_id=${zoho_integration_id}`)
}

const getThreadDetails = {
    get: (thread_id: string, flag_debugging: string, limit: number, offset: number) => requests.get(`api/thread/get-thread-details?thread_id=${thread_id}&flag_debugging=${flag_debugging}&limit=${limit}&offset=${offset}`)
}

const getThreadDetailsByPhoneNumber = {
    get: (integrated_channel_id: string, user_wa_phone_number: string, flag_debugging: string, limit: number, offset: number) => requests.get(`api/thread/get-thread-details?integrated_channel_id=${integrated_channel_id}&user_wa_phone_number=${user_wa_phone_number}&flag_debugging=${flag_debugging}&limit=${limit}&offset=${offset}`)
}

const getChatbotType = {
    get: () => requests.get('api/global/get-chatbot-type')
}
const createChatbotFlow = {
    post: (payload: createWorkflowInterface) => requests.post('api/chatbot-config/create-chatbot', payload)
}
const getChatbotConfig = {
    get: (chatbot_id?: string) => requests.get(!chatbot_id ? `api/chatbot-config/get-chatbot` : `api/chatbot-config/get-chatbot/${chatbot_id}`)
}
const addThreadManualAgentAPI = {
    post: (payload: addThreadManualAgent) => requests.post('api/thread/add-manual-agent', payload)
}
const updateManualAgentStatus = {
    put: (thread_manual_agent_id: string, flag_send_agent_activity_message: boolean) => requests.put(`api/thread/update-manual-agent-status?thread_manual_agent_id=${thread_manual_agent_id}&flag_send_agent_activity_message=${flag_send_agent_activity_message}`, {})
}
const removeManualAgent = {
    delete: (thread_manual_agent_id: string, flag_send_agent_activity_message: boolean) => requests.delete(`api/thread/remove-manual-agent?thread_manual_agent_id=${thread_manual_agent_id}&flag_send_agent_activity_message=${flag_send_agent_activity_message}`)
}
const getMessageAISteps = {
    get: (thread_id: string, ai_message_execution_id: string) => requests.get(`api/chatbot/get-message-ai-steps?thread_id=${thread_id}&ai_message_execution_id=${ai_message_execution_id}`)
}
const manualOverrideNewStructure = {
    post: (payload: manualOverrideNewStructurePayloadInterface) => requests.post('api/thread/send-manual-message', payload)
}
const getChatbotCustomVariable = {
    get: (chatbot_id: string) => requests.get(`api/chatbot-config/get-chatbot-custom-variable?chatbot_id=${chatbot_id}`)
}
const getGenericMetadataVariableType = {
    get: () => requests.get(`api/global/generic-metadata-type`)
}
const addChatbotCustomVariable = {
    put: (payload: addChatbotCustomVariablePayload | addChatbotCustomVariablesPayload) => requests.put(`api/chatbot-config/add-chatbot-custom-variable`, payload),
}
const updateChatbotCustomVariable = {
    put: (payload: updateChatbotCustomVariablePayload) => requests.put(`api/chatbot-config/add-chatbot-custom-variable`, payload),
}
const deleteChatbotCustomVariable = {
    delete: (chatbot_custom_variable_configuration_id: string) => requests.delete(`api/chatbot-config/delete-chatbot-custom-variable?chatbot_custom_variable_configuration_id=${chatbot_custom_variable_configuration_id}`)
}
const mapParentChatbotWithSubChatbot = {
    post: (payload: mapParentChatbotWithSubChatbotPayload) => requests.post('api/chatbot/sub-chatbot', payload)
}
const getSubChatbotExecutionLog = {
    get: (ai_execution_id: string) => requests.get(`api/chatbot/sub-chatbot-execution-log?ai_execution_id=${ai_execution_id}`)
}

const getDashboardAnalyticsData = {
    get: (start_date: string, end_date: string, chatbot_id: string, timezone: string) => requests.get(`api/campaign/analytics?start_date=${start_date}&end_date=${end_date}&chatbot_id=${chatbot_id}&timezone=${timezone}`)
}

const getAnalyticsIntentExecution = {
    get: (start_date: string, end_date: string, chatbot_id: string, timezone: string) => requests.get(`api/analytics_intent/intent_execution?start_date=${start_date}&end_date=${end_date}&chatbot_id=${chatbot_id}&timezone=${timezone}`)
}

const batchUpdateChatbotSteps = {
    put: (chatbot_id: string, payload: any) => requests.put(`api/chatbot-config/${chatbot_id}/step-batch-update`, payload)
}
const updateChatbotDeploymentDetails = {
    put: (payload: updateChatbotPayload) => requests?.put('/api/chatbot-config/update-chatbot', payload)
}
const publishChatbot = {
    post: (chatbot_id: string, flag_close: boolean) => requests.post(`api/chatbot-config/${chatbot_id}/publish?flag_close=${flag_close}`, {})
}
const contactTagActions = {
    put: (payload: contactTagActionsPayload) => requests.put('api/contact/contact-tag-actions', payload)
}
// WA Flow
const getWAFlowList = {
    get: (meta_integration_whatsapp_id: string) => requests.get(`api/whatsapp-flow?meta_integration_whatsapp_id=${meta_integration_whatsapp_id}`)
}
const getWAFlowDetails = {
    get: (meta_integration_whatsapp_id: string, whatsapp_flow_id: string) => requests.get(`api/whatsapp-flow?meta_integration_whatsapp_id=${meta_integration_whatsapp_id}&whatsapp_flow_id=${whatsapp_flow_id}`)
}
const createWAFlow = {
    post: (payload: CreateWhatsappFlowRequest) => requests.post('api/whatsapp-flow', payload)
}
const updateWAFlow = {
    put: (payload: UpdateWhatsappFlowRequest) => requests.put('api/whatsapp-flow', payload)
}
const deleteWAFlow = {
    delete: (whatsapp_flow_id: string) => requests.delete(`api/whatsapp-flow?whatsapp_flow_id=${whatsapp_flow_id}`)
}
const publishWAFlow = {
    post: (payload: publishWhatsAppFlowPayload) => requests.post(`api/whatsapp-flow/publish`, payload)
}

const getCannedResponseTemplateData = {
    get: (canned_response_template_id: string | null) => {
        const params = new URLSearchParams();
        if (canned_response_template_id) {
            params.append("canned_response_template_id", canned_response_template_id);
        }

        return requests.get(`api/canned/response-template?${params.toString()}`);
    }
}

const manageCannedResponse = {
    post: (payload: CannedResponseTemplate) => requests.post(`api/canned/response-template`, payload),
}

const deleteCannedResponseTemplate = {
    delete: (canned_response_template_id: string) => requests.delete(`api/canned/response-template?canned_response_template_id=${canned_response_template_id}`),
}

const sendCannedResponse = {
    post: (payload: sendCannedResponsePayload) => requests.post(`api/thread/send-canned-response`, payload),
}

const getGenericContentTypes = {
    get: () => requests.get(`api/global/content-type`),
}

const addContactChatbotAssignment = {
    post: (payload: addContactChatbotAssignmentPayload) => requests.post(`api/contact/contact-chatbot-assignment`, payload),
}

const deleteContactChatbotAssignment = {
    delete: (chatbot_id: number, contact_chatbot_assignment_id: number, contact_id: number) => requests.delete(`api/contact/contact-chatbot-assignment?chatbot_id=${chatbot_id}&contact_chatbot_assignment_id=${contact_chatbot_assignment_id}&contact_id=${contact_id}`),
}

const getOperatorType = {
    get: () => requests.get(`api/global/operator-type`),
}

const getIntegratedChannelDeploymentTrigger = {
    get: (campaign_id: string) => requests.get(`api/channel_deployment/integrated_channel_deployment_trigger?campaign_id=${campaign_id}`),
}

const saveIntegratedDeploymentTrigger = {
    put: (payload: DeploymentTriggerPayload) => requests.put(`api/channel_deployment/integrated_channel_deployment_trigger`, payload),
}
const sendWhatsAppTemplate = {
    post: (payload: sendTemplatePayload) => requests.post(`api/thread/send-wa-template`, payload),
}

const getGptModelList = {
    get: () => requests.get('api/global/gpt-models')
}

const getVoiceAgentsModelList = {
    get: () => requests.get('api/global/voice-agent-model')
}

const getGlobalCountryCode = {
    get: () => requests.get(`api/global/country-code`),
}

const getChatbotPostDeploymentTriggerType = {
    get: () => requests.get(`api/global/chatbot-post-deployment-trigger-type`),
}

const handleChatbotPostDeploymentTrigger = {
    post: (payload: postDeploymentTriggerPayload, chatbot_id: string) => requests.post(`api/chatbot-config/chatbot-post-deployment-trigger?chatbot_id=${chatbot_id}`, payload),
}

const getChatbotPostDeploymentTrigger = {
    get: (chatbot_id: string) => requests.get(`api/chatbot-config/chatbot-post-deployment-trigger?chatbot_id=${chatbot_id}`),
}

const getWebhookExternal = {
    get: () => requests.get(`api/external-webhook/webhook-external`),
}

const createUpdateWebhookExternal = {
    post: (payload: payloadCreateUpdateWebhook) => requests.post(`api/external-webhook/webhook-external`, payload)
}

const getWebhookOrganizationList = {
    get: () => requests.get(`api/external-webhook/webhook-organization`),
}

const createUpdateWebhookOrganization = {
    post: (payload: payloadConfigureWebhook) => requests.post(`api/external-webhook/webhook-organization`, payload),
}

const getWAFlowPreviewURL = {
    get: (whatsapp_flow_id: string) => requests.get(`api/whatsapp-flow/preview-url?whatsapp_flow_id=${whatsapp_flow_id}`)
}
const getGenericDataTypeList = {
    get: () => requests.get('api/global/data-type')
}

const getVendors = {
    get: () => requests.get(`api/vendor`)
}

const getVendorDetails = {
    get: (vendor_id: number) => requests.get(`api/vendor?vendor_id=${vendor_id}`)
}

const deleteThread = {
    delete: (thread_id: string) => requests.delete(`api/thread/delete-thread?thread_id=${thread_id}`)
}

const deleteChatbotWorkflow = {
    delete: (chatbot_id: string) => requests.delete(`api/chatbot-config/delete-chatbot/${chatbot_id}`)
}

const getChatbotStatus = {
    get: () => requests.get(`api/global/get-status`),
}

const updateChatbotStatus = {
    put: (chatbot_id: string, payload: updateChatbotStatusPayload) => requests.put(`api/chatbot-config/${chatbot_id}/update-chatbot-status`, payload),
}

const getInteractiveType = {
    get: () => requests.get(`api/global/interactive-types`),
}

const getEComProduct = {
    get: (organization_id: string) => requests.get(`api/ecom/product?organization_id=${organization_id}`)
}

const listOrders = {
    get: (organization_id: string | number, ecom_order_id?: string | null, start?: number | null, limit?: number | null, search_text?: string | null, flag_paid_only?: boolean | null, flag_not_paid_only?: boolean | null) => {
        const params = new URLSearchParams();

        if(ecom_order_id) params.append("ecom_order_id", ecom_order_id)
        if(start) params.append("start", String(start))
        if(limit) params.append("limit", String(limit))
        if(search_text) params.append("search_text", search_text)
        if(flag_paid_only != null) params.append("flag_paid_only", String(flag_paid_only));
        if(flag_not_paid_only != null) params.append("flag_not_paid_only", String(flag_not_paid_only));
        
        return requests.get(`api/ecom/list-orders/${organization_id}?${params.toString()}`)
    }
}

const checkPaymentStatus = {
    post: (payload: checkPaymentStatuspayload) => requests.post(`api/ecom/check-payment-status`, payload),
}

const grantAccess = {
    post: (payload: grantaccessPayload) => requests.post(`api/ecom/grant-access`, payload),
}

const updateOrganizationName = {
    put: (payload: updateOrganizationNamePayload) => requests.put(`api/organization/update-name`, payload),
}

const resendQrCode = {
    post: (payload: resendQrCodePayload) => requests.post(`api/ecom/resend-qr-code`, payload),
}

const onBoardingProcess = {
    put: (payload: completeOnboardingProcessPayload) => requests.put("api/dev_portal/complete-user-onboarding", payload),
}

const getAnalyticsIntent = {
    get: () => requests.get(`api/analytics_intent`),
}

const deleteAnalyticsIntent = {
    delete: (intent_id: string) => requests.delete(`api/analytics_intent?intent_id=${intent_id}`),
}

const createUpdateAnalyticsIntent = {
    post: (payload: createUpdateIntentPayload) => requests.post(`api/analytics_intent`, payload),
}

const uploadProductDataFromCSV = {
    post: (payload: uploadProductDataFromCSVPayload) => requests.post(`api/ecom/product-from-csv`, payload),
}

const deleteEComProduct = {
    put: (payload: deleteEComProductsPayload) => requests.put(`api/ecom/product/delete`, payload),
}

const addEComProduct = {
    post: (payload: createUpdateProductPayload) => requests.post(`api/ecom/product`, payload),
}

const updateEComProduct = {
    put: (payload: createUpdateProductPayload) => requests.put(`api/ecom/product`, payload),
}

const getKnowledgeBaseFiles = {
    get: () => requests.get(`api/knowledge-base/files`),
}

const createKnowledgeBaseFile = {
    post: (payload: createKnowledgeBaseFilesPayload) => requests.post(`api/knowledge-base/files`, payload),
} 

const deleteKnowledgeBaseFile = {
    delete: (knowledge_base_file_id: string) => requests.delete(`api/knowledge-base/files/${knowledge_base_file_id}`), 
}

const getOrganizationUserRole = {
    get: () => requests.get(`api/global/organization-user-role`),
}

const createUserCallbackRequest = {
    post: (payload: requestCallbackPayload) => requests.post(`api/user/create-user-callback-request`, payload),
}

const getMediaType = {
    get: () => requests.get(`api/global/media-type`),
}

const updateUserDetails = {
    put: (payload: updateUserDetail) => requests.put(`api/user/update-user-details`, payload),
}
const updateUserPassword = {
    put: (payload: updateUserPasswordPayload) => requests.put(`api/user/update-password`, payload),
}
const reportIssue = {
    post: (payload: reportIssuePayload) => requests.post(`api/global/report-issue`, payload),
}
const fcmRegisterToken = {
    post: (payload: { fcm_token_value: string }) => requests.post(`api/fcm/register-token`, payload),
}

const checkFcmToken = {
    get: (fcm_token_value: string) => requests.get(`api/fcm/check-token?fcm_token_value=${fcm_token_value}`)
}

//voice ai api calls
const checkCallingEnabled = {
    get: (phone_number_id: string) => requests.get(`api/whatsapp-voice-call/check-calling-enabled?phone_number_id=${phone_number_id}`)
}

const enableCallNumber = {
    post: (payload: enableCallPayload) => requests.post(`api/whatsapp-voice-call/enable-calling`, payload),
}

const checkUserAllowedToCall = {
    get: (phone_number_id: string, user_wa_id: string, thread_id: string) => requests.get(`api/whatsapp-voice-call/check-call-permission?phone_number_id=${phone_number_id}&user_wa_id=${user_wa_id}&thread_id=${thread_id}`)
}

const askCallPermissionUser = {
    post: (payload: askCallPermissionPayload) => requests.post(`api/whatsapp-voice-call/ask-call-permission`, payload)
}

const getDataConnectorAssignment = {
    get: (data_connector_assignment_id: number) => requests.get(`api/data-connector/assignment?data_connector_assignment_id=${data_connector_assignment_id}`)
}
//getDataConnectorDetail already declared

const getVoiceAgentList = {
    get: () => requests.get(`api/voice-agent`)
}

const getVoiceAgent = {
    get: (voice_agent_id: string) => requests.get(`api/voice-agent/get-voice-agent?voice_agent_id=${voice_agent_id}`)
}

const createVoiceAgent = {
    post: (payload: createVoiceAgentPayload) => requests.post(`api/voice-agent`, payload)
}

const updateVoiceAgent = {
    put: (payload: createVoiceAgentPayload) => requests.put(`api/voice-agent`, payload)
}

const getVoiceAgentField = {
    get: () => requests.get(`api/global/voice-agent-field`)
}

const deleteVoiceAgent = {
    delete: (voice_agent_id: string) => requests.delete(`api/voice-agent?voice_agent_id=${voice_agent_id}`)
}
//createDataConnectorAssignment already declared

const assignVoiceAgent = {
    put: (payload: assignVoiceAgentInterface) => requests.put(`api/voice-agent/assign-voice-agent`, payload)
}

const getVoiceAgentAssignment = {
    get: (meta_integration_whatsapp_phone_number_id: number) => requests.get(`api/voice-agent/get-voice-agent-assignment?meta_integration_whatsapp_phone_number_id=${meta_integration_whatsapp_phone_number_id}`)
}

const initialCallRequest = {
    post: (payload: initialCallInterface) => requests.post(`api/whatsapp-voice-call/initiate-call`, payload)
}

const acceptIncomingCall = {
    post: (payload: acceptCallInterface) => requests.post(`api/whatsapp-voice-call/handle-inbound-call`, payload)
}

const endIncomingCall = {
    post: (payload: endCallInterface) => requests.post(`api/whatsapp-voice-call/end-call`, payload)
}

const endCall = {
    post: (payload: endCallInterface) => requests.post(`api/whatsapp-voice-call/end-call`, payload)
}

const aiAgentVoice = {
    get: () => requests.get(`api/global/ai-agent-voice`)
}

const getAssignmentStrategyType = {
    get: () => requests.get(`api/global/assignment-strategy-type`),
}

const assignThreadStatus = {
    put: (payload: assignThreadStatusPayload) => requests.put(`api/thread/assign-thread-status`, payload),
}

const getThreadTags = {
    get: () => requests.get(`api/ticket/tag/list`),
}

const addThreadtags = {
    post: (payload: addThreadTagPayload) => requests.post(`api/ticket/tag`, payload),
}

const updateThreadTags = {
    put: (payload: updateThreadTagPayload) => requests.put(`api/ticket/tag`, payload),
}

const deleteThreadTags = {
    delete: (ticket_tag_id: string) => requests.delete(`api/ticket/tag?ticket_tag_id=${ticket_tag_id}`),
}

const assignThreadTags = {
    put: (payload: assignThreadTagsPayload) => requests.put(`api/thread/assign-thread-tags`, payload),
}

const assignThreadNotes = {
    put: (payload: asignThreadNotePayload) => requests.put(`api/thread/update-thread-notes`, payload),
}

const getChatbotTriggerConfig = {
    get: (chatbotId: string) => requests.get(`api/chatbot-trigger-config/${chatbotId}`),
}

const updateChatbotTriggerConfig = {
    put: (payload: updateChatbotTriggerConfigs) => requests.put(`api/chatbot-trigger-config`, payload),
}

const getApiKey = {
    get: () => requests.get(`api/api-key/get-api-keys`),
}

const createApiKey = {
    post: (payload: createApiKeyPayload) => requests.post(`api/api-key/create-api-key`, payload),
}

const deleteApiKey = {
    delete: (api_key_id: string) => requests.delete(`api/api-key/delete-api-key?api_key_id=${api_key_id}`),
}

const getRuleBasedInboxThreads = {
    get: (payload: getRuleBasedInboxThreadsPayload) => {
        const params = new URLSearchParams();

        Object.entries(payload).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        return requests.get(`api/thread/inbox?${params.toString()}`);
    }
}

const updateRuleBasedInboxThreadArchiveStatus = {
    put: (payload: updateRuleBasedInboxThreadArchiveStatusPayload) => requests.put(`api/thread/update-thread-archive`, payload),
}

const callCustomApiFromInbox = {
    post: (payload: smartAssistPayload) => requests.post(`api/inbox/call-custom-api`, payload),
}

const archiveTemplate = {
    delete: (whatsapp_template_id: number, meta_integration_whatsapp_id: number) => requests.delete(`api/meta-integration/archive-whatsapp-template?whatsapp_template_id=${whatsapp_template_id}&meta_integration_whatsapp_id=${meta_integration_whatsapp_id}`)
} 

const getWhatsAppPricing = {
    get: () => requests.get(`api/global/whatsapp-pricing`),
}

const getActionType = {
    get: () => requests.get(`api/global/get-action-type`)
}

const getChronoxUserRolesGeneric = {
    get: () => requests.get(`api/route-config/chronox-user-role`),
}

const getUserAssignmentRoles = {
    get: () => requests.get(`api/route-config/user-assignment-role`),
}

const createUserAssignmentRole = {
    post: (payload: createUserAssignmentRolePayload) => requests.post(`api/route-config/user-assignment-role`, payload),
}

const updateUserAssignmentRole = {
    put: (payload: updateUserAssignmentRolePayload) => requests.put(`api/route-config/user-assignment-role`, payload),
}

const deleteUserAssignmentRole = {
    delete: (user_assignment_role_id: string) => requests.delete(`api/route-config/user-assignment-role?user_assignment_role_id=${user_assignment_role_id}`),
}

const getAPIRoutesPermissionAssignments = {
    get: (chronox_user_role_id: string) => requests.get(`api/route-config/api-routes-permission-assignment?chronox_user_role_id=${chronox_user_role_id}`)
}

const updateUserStatus = {
    put: (payload: updateUserStatusPayload) => requests.put(`api/user/update-user-status`, payload)
}

const getCarouselTemplateGroups = {
    get: (meta_integration_whatsapp_id?: number) => {
        const params = new URLSearchParams();
        if (meta_integration_whatsapp_id) {
            params.append("meta_integration_whatsapp_id", String(meta_integration_whatsapp_id));
        }

        return requests.get(`api/message-format/carousel-template-group?${params.toString()}`);
    }
}

const deleteCarouselTemplateGroups = {
    delete: (carousel_template_group_id: string) => requests.delete(`api/message-format/carousel-template-group?carousel_template_group_id=${carousel_template_group_id}`)
}

const createCarouselTemplateGroups = {
    post: (payload: createCarouselTemplateGroupPayload) => requests.post(`api/message-format/carousel-template-group`, payload)
}

const updateCarouselTemplateGroups = {
    put: (payload: updateCarouselTemplateGroupPayload) => requests.put(`api/message-format/carousel-template-group`, payload)
}

const getTicketField = {
    get: () => requests.get(`api/global/thread-ticket-field`),
}

const getTicketStatusList = {
    get: () => requests.get(`api/thread-ticket/get-status-list`),
}

const deleteTicketSubStatus = {
    delete: (ticket_status_id: string) => requests.delete(`api/thread-ticket/delete-status?ticket_status_id=${ticket_status_id}`)
}

const createTicketSubStatus = {
    post: (payload: createSubStatusPayload) => requests.post(`api/thread-ticket/create-status`, payload)
}

const updateTicketSubStatus = {
    put: (payload: updateSubStatusPayload) => requests.put(`api/thread-ticket/update-status`, payload)
}

const createThreadTicket = {
    post: (payload: createTicketPayload) => requests.post(`api/thread-ticket/create-ticket`, payload)
}

const updateThreadTicket = {
    put: (payload: updateTicketPayload) => requests.put(`api/thread-ticket/update-ticket`, payload)
}

const updateDirectSendCannedMsg = {
    put: (payload: updateDirectSendCannedMsgPayload) => requests.put(`api/canned/update-direct-canned-message`, payload)
}

const getTemplateLibraryUseCase = {
    get: () => requests.get(`api/global/template-library-use-case`)
}

const getTemplateLibraryCategory = {
    get: () => requests.get(`api/global/whatsapp-template-category`)
}

const getTemplateLibraryIndustry = {
    get: () => requests.get(`api/global/template-library-industry`)
}

const getTemplateLibraryList = {
    get: () => requests.get(`api/template-library`)
}

const getTemplateLibraryDraftList = {
    get: () => requests.get(`api/template-library/draft`)
}

const createDraftTemplate = {
    put: (payload: createTemplateLibraryDraftPayload) => requests.put(`api/template-library/draft`, payload)
}

const deleteDraftTemplate = {
    delete: (whatsapp_template_draft_id: string) => requests.delete(`api/template-library/draft?whatsapp_template_draft_id=${whatsapp_template_draft_id}`)
}

const getAgentActivityMessageTypes = {
    get: (channel_id: number) => requests.get(`api/global/agent-activity-message-types?channel_id=${channel_id}`)
}

const getAgentActivityMessageVariableType = {
    get: () => requests.get(`api/global/agent-activity-message-variable-types`)
}

const enableDisableAgentActivityMsg = {
    post: (payload: enableDisableAgentActivityMsgPayload) => requests.post(`api/meta-integration/enable-agent-activity-message`, payload)
}

const getPaymentConfigurations = {
    get: (waba_id: string) => requests.get(`api/meta-integration/whatsapp-payment-configuration?waba_id=${waba_id}`)
}

const syncMetaPaymentConfig = {
    get: (meta_integration_whatsapp_id: string) => requests.get(`api/meta-integration/whatsapp-payment-configuration/sync-meta?meta_integration_whatsapp_id=${meta_integration_whatsapp_id}`)
}

const toggleSmbAgentAssignment = {
    post: (payload: toggleSmbAgentAssignmentPayload) => requests.post(`api/meta-integration/enable-smb-agent-assignment`, payload)
}

const getEmojiList = {
    get: () => requests.get(`api/global/reaction-emoji`)
}

const getWebhookPayloadkey = {
    get: () => requests.get(`api/global/whatsapp-webhook-payload-key`)
}

const getAILLMPlatform = {
    get: () => requests.get(`api/global/ai-llm-platform`)
}

const getOrganizationTeamsList = {
    get: () => requests.get(`api/organization-team`)
}

const getOrganizationTeamDetails = {
    get: (organization_team_id: string) => requests.get(`api/organization-team?organization_team_id=${organization_team_id}`)
}

const createOrganizationTeam = {
    put: (payload: createOrganizationTeamPayload) => requests.put(`api/organization-team`, payload)
}

const deleteOrganizationTeam = {
    delete: (organization_team_id: string) => requests.delete(`api/organization-team?organization_team_id=${organization_team_id}`)
}

const getCatalogProductOptionalFields = {
    get: () => requests.get(`api/global/catalog-product-optional-fields`)
}

const getWhatsAppCatalogs = {
    get: () => requests.get(`api/meta-integration/waba-catalogs`),
}

const getLeadOrders = {
    get: (limit: string, offset: string) => requests.get(`api/conversion-api/lead-order?limit=${limit}&offset=${offset}`)
}

const updateLeadOrderStatus = {
    put: (payload: updateLeadOrderStatusPayload) => requests.put(`api/conversion-api/lead-status`, payload)
}

const updatePaymentStatus = {
    put: (payload: updatePaymentStatusPayload) => requests.put(`api/ecom/update-payment-status`, payload)
}

const syncCatalog = {
    post: (payload: syncCatalogPayload) => requests.post(`api/ecom/catalog-sync`, payload)
}

const getAllIntegratedChannels = {
    get: () => requests.get(`api/meta-integration/integrated-channels`)
}

// Instagram Integration
const getInstagramCommentTrigger = {
    get: (chatbot_integrated_channel_deployment_id: string) => requests.get(`api/meta-integration/instagram-comment-trigger?chatbot_integrated_channel_deployment_id=${chatbot_integrated_channel_deployment_id}`)
}

const createInstagramCommentTrigger = {
    post: (payload: instagramCommentTriggerPayload) => requests.post(`api/meta-integration/instagram-comment-trigger`, payload)
}

const updateInstagramCommentTrigger = {
    put: (payload: instagramCommentTriggerPayload) => requests.put(`api/meta-integration/instagram-comment-trigger`, payload)
}

const deleteInstagramCommentTrigger = {
    delete: (chatbot_integrated_channel_deployment_trigger_id: string) => requests.delete(`api/meta-integration/instagram-comment-trigger?chatbot_integrated_channel_deployment_trigger_id=${chatbot_integrated_channel_deployment_trigger_id}`)
}

// Billing API
const getPricingPlans = {
    get: () => billingRequests.get(`api/billing/pricing`)
}

const getAddOns = {
    get: () => billingRequests.get(`api/billing/add-ons`)
}

const subscribePlan = {
    post: (payload: subscribePlanPayload) => billingRequests.post(`api/billing/subscribe`, payload)
}

const getSubscriptionStatus = {
    get: (billing_subscription_id: string) => billingRequests.get(`api/billing/subscription-status?billing_subscription_id=${billing_subscription_id}`)
}

const getSubscriptionDetails = {
    get: () => billingRequests.get(`api/billing/subscription-details`)
}

const getTransactionStatus = {
    get: () => billingRequests.get(`api/billing/transaction-statuses`)
}

const purchaseAiCredits = {
    post: (payload: purchaseAiCreditsPayload) => billingRequests.post(`api/billing/purchase-add-on`, payload)
}

// WABA Verification
const getWabaApprovalStatus = {
    get: (organization_id: string) => requests.get(`api/waba-approval/waba-integration-request-details?organization_id=${organization_id}`)
}

const submitWabaIntegrationRequest = {
    post: (payload: wabaVerificationRequestPayload) => requests.post(`api/waba-approval/submit-waba-integration-request`, payload)
}

const updateAIChatbotKnowledgeBase = {
    put: (payload: AssignKnowledgeBaseChatbotRequest) => requests.put(`api/chatbot/knowledge-base`, payload),
}

// Import Rule Based Chatbot
const importRuleBasedChatbot = {
    put: (payload: any, chatbot_id: string) => requests.put(`api/chatbot-config/${chatbot_id}/import-chatbot`, payload),
}

const agent = {
    UserMeAPI,
    RegisterAPI,
    SendAccountOTPAPI,
    VerifyAccountOTPAPI,
    SendLoginOTPAPI,
    VerifyLoginOTPAPI,
    loginWithPasswordAPI,
    LogoutAPI,
    getUserAdditionalInfo,
    getUserAdditionalInfoGenericData,
    addUserAdditionalInfo,
    getTemplateList,
    getTemplateDetail,
    createDoc,
    getDocDetails,
    getDocList,
    updateDocumentFormSubmissionData,
    updateDocumentInfo,
    getPrompList,
    executePrompt,
    getDocumentContentTypeData,
    deleteDocument,
    updateDocumentOutlineData,
    deleteDocumentOutlineData,
    updateDocumentTitle,
    updateDocumentEditorDetail,
    contWithGoogle,
    getCustomerDetail,
    updateCustomerDetail,
    getPricingDetail,
    getStripeCustomerSubscriptionDetail,
    getStripeCustomerPortalLink,
    getPersonaList,
    getPersonaDetails,
    createNewPersona,
    updatePersona,
    getDefaultPersonaTypeList,
    markDefaultPersona,
    removeDefaultPersona,
    deletePersona,
    getPersonaWritingSkillsDetails,
    getReadingSkillsDetails,
    getSentenceLengthDetails,
    getNarrativeTypeDetails,
    getCommunicationTypeDetails,
    oneTapLoginAuthCallback,
    getBannerData,
    fileUpload,
    createCustomTemplate,
    updateCustomTemplate,
    deleteCustomTemplate,
    cancelStripeSubscription,
    UpdateStripeSubscription,
    createChatbot,
    getChatbotData,
    getFileDetail,
    uploadFile,
    batchImportCallAnalysis,
    removeUploadedFile,
    getChatbotList,
    updateChatbotData,
    addChatbotDomain,
    updateChatbotDomain,
    deleteChatbotDomain,
    getCampaignList,
    createCampaignList,
    getCampaignDetails,
    updateCampaignDetails,
    removeCampaign,
    getTemplateCampaignList,
    generateCampaignDocument,
    getCampaignDocuemnts,
    removeChatbot,
    getRewriteToneGenericList,
    getWorkDomainList,
    getLanguageList,
    getRouteSourceIds,
    getOutputFormatGenericList,
    getSystemPersonaPublicList,
    getStripeCurrencyTypeGenericList,
    getPromptLogFieldsGenericList,
    getDialectList,
    getPopupList,
    createUserPopupAction,
    resetChatbotSession,
    removeFile,
    getMetaCredentials,
    createChatbotIntegration,
    getChatbotIntegrationData,
    deleteChatbotIntegration,
    LoaderDetailsAPI,
    getChatbotThreadsList,
    getChatbotThreadDetails,
    getCountryCode,
    getChatLogs,
    getAllChatLogs,
    getChatbotDataConnectorList,
    getDataConnectorAssignmentType,
    createDataConnectorAssignment,
    deleteDataConnectorAssignment,

    // manageChatbotDataConnector, 
    manageDataConnector,

    manageDataConnectorPlatformList,
    // deleteChatbotDataConnector,
    deleteDataConnector,

    // getChatbotDataConnectorDetail, 
    getDataConnectorDetail,

    getFunctionMethods,
    getFunctionParameterTypeData,
    updateFlagInternal,
    getMetaIntegration,
    createMetaIntegration,
    deleteMetaIntegration,
    // getMetaIntegrationType,
    syncWhatsappTemplate,
    getChannelList,
    getWhatsappTemplateButtonType,
    createWhatsappTemplate,
    getWhatsappTemplateList,
    getWhatsappTemplateDetails,
    updateWhatsappTemplate,
    whatsappTemplateDynamicVariableType,
    whatsappTemplateHeaderType,
    whatsappTemplateFooterType,
    createWhatsappTemplateNew,
    getWhatsappTemplateType,
    addChatbotIntegration,
    removeChatbotIntegration,
    getGenericTimezone,
    updateUserTimezone,
    getChatThreadData,
    shareOrganizationInvitation,
    acceptOrganizationInvitation,
    removeUserFromOrganization,
    updateUserOrganizationRole,
    getOrganizationDetails,
    removeDelegateAccess,
    whatsappTryNowNumbers,
    addTryNowPhoneNumbers,
    getChatbotTryNowPhoneNumbers,
    submitFeedback,
    getFile,
    createPersistentMenuAPI,
    removePersistentMenuDataAPI,
    updatePersistentMenuAPI,
    getPlaygroundURl,
    getCallCategory,
    getCallComplexity,
    getCallEvaluationParameter,
    getCallAgent,
    getCallParentCategory,
    getCallRecords,
    getCallEvaluationScoreColor,
    getPhoneNumbersList,
    getExtensionsList,
    regenerateCallRecord,
    importCallRecord,
    getCallRecordDetails,
    getCallAnalysisAdditionalField,
    getCallAnalysisFeedbackType,
    getCallAnalysisOption,
    getCallAnalysisFeedback,
    createCallAnalysisFeedback,
    updateCallAnalysisFeedback,
    createAgentAPI,
    resetChatbotThreadByAdmin,
    closeStaticWorkflowThread,
    updateCallRecords,
    calendlyAuthUrlApi,
    getCallbackStatus,
    getCalendlyIntegrationData,
    postChatbotCalendlyEventTypeData,
    deleteChatbotCalendlyIntegration,
    getCustomPages,
    getGenericFieldTypeData,
    getLeadIntegrationTypeData,
    createLeadGeneration,
    updateLeadGeneration,
    getLeadGenerationData,
    deleteLeadGeneration,
    manageLeadGeneration,
    deleteLeadIntegration,
    getIntegrations,
    getSlackintegrations,
    createChatbotSlackIntegration,
    deleteChatbotSlackIntegration,
    deleteSlackIntegration,
    handleToggleManualOverride,
    getStaticMessageFormat,
    createStaticMessageFormat,
    updateStaticMessageFormat,
    deleteStaticMessageFormat,
    getProductListData,
    getFeedbackProvidedType,
    getFeedbackLevel,
    getListOfFeedbackOption,
    addFeedback,
    getFeedbackStatus,
    getFeedbackModificationStatus,
    getFeedback,
    updateFeedback,
    uploadCartItems,
    getCampaignContactList,
    createCampaignContactList,
    updateCampaignContactList,
    archiveContactList,
    deleteContactList,
    getCampaignContact,
    updateCampaignContact,
    deleteCampaignContact,
    createCampaignContact,
    importCampaignContactData,
    getListOfCampaignContactField,
    createCampaignContactField,
    updateCampaignContactField,
    deleteCampaignContactField,
    getListOfCampaignFieldType,
    getListOfCampaignContactTag,
    createCampaignContactTag,
    updateCampaignContactTag,
    deleteCampaignContactTag,
    createCampaign,
    getCampaignData,
    getMultipleCampaignData,
    getCampaignMessageType,

    getCampaignContactFilterType,
    getCampaignExecutionStatus,

    runCampaign,
    resumeCampaign,
    archiveCampaign,
    pauseCampaign,
    deleteCampaign,
    updateCampaign,
    createZohoIntegrationOrganizationChatbotAssignment,
    deleteZohoIntegrationChatbotAssignment,
    getZohoIntegration,
    getThreadDetails,
    getThreadDetailsByPhoneNumber,
    getChatbotType,
    createChatbotFlow,
    getChatbotConfig,
    getZohoTicketFields,
    getListOfZohoContact,
    getListOfZohoDepartment,
    deleteZohoIntegration,
    getZohoTicketLogs,
    addThreadManualAgentAPI,
    removeManualAgent,
    updateManualAgentStatus,
    getMessageAISteps,
    manualOverrideNewStructure,
    getChatbotCustomVariable,
    addChatbotCustomVariable,
    updateChatbotCustomVariable,
    deleteChatbotCustomVariable,
    batchUpdateChatbotSteps,
    mapParentChatbotWithSubChatbot,
    updateChatbotDeploymentDetails,
    getSubChatbotExecutionLog,
    publishChatbot,
    getDashboardAnalyticsData,
    getAnalyticsIntentExecution,
    contactTagActions,
    getWAFlowList,
    getWAFlowDetails,
    createWAFlow,
    updateWAFlow,
    deleteWAFlow,
    publishWAFlow,

    getCannedResponseTemplateData,
    manageCannedResponse,
    deleteCannedResponseTemplate,
    sendCannedResponse,
    getGenericContentTypes,

    addContactChatbotAssignment,
    deleteContactChatbotAssignment,
    getOperatorType,
    getIntegratedChannelDeploymentTrigger,
    saveIntegratedDeploymentTrigger,

    sendWhatsAppTemplate,
    getGptModelList,
    getVoiceAgentsModelList,
    getGlobalCountryCode,
    getChatbotPostDeploymentTriggerType,
    handleChatbotPostDeploymentTrigger,
    getChatbotPostDeploymentTrigger,
    getGenericMetadataVariableType,
    getWebhookExternal,
    createUpdateWebhookExternal,
    getWebhookOrganizationList,
    createUpdateWebhookOrganization,
    getWAFlowPreviewURL,
    getGenericDataTypeList,
    getVendors,
    getVendorDetails,
    deleteThread,
    deleteChatbotWorkflow,
    getChatbotStatus,
    updateChatbotStatus,
    getInteractiveType,
    getEComProduct,
    listOrders,
    checkPaymentStatus,
    grantAccess,
    updateOrganizationName,
    resendQrCode,
    onBoardingProcess,
    getAnalyticsIntent,
    deleteAnalyticsIntent,
    createUpdateAnalyticsIntent,
    uploadProductDataFromCSV,
    deleteEComProduct,
    addEComProduct,
    updateEComProduct, 
    getKnowledgeBaseFiles, 
    createKnowledgeBaseFile, 
    deleteKnowledgeBaseFile,
    getOrganizationUserRole,
    createUserCallbackRequest,
    getMediaType,
    reportIssue,
    updateUserDetails,
    updateUserPassword,
    fcmRegisterToken,
    checkFcmToken, 
    getAssignmentStrategyType,
    checkCallingEnabled,
    enableCallNumber,
    checkUserAllowedToCall,
    askCallPermissionUser,
    getDataConnectorAssignment,
    getVoiceAgentList,
    getVoiceAgent,
    createVoiceAgent,
    updateVoiceAgent,
    getVoiceAgentField,
    deleteVoiceAgent,
    assignVoiceAgent,
    getVoiceAgentAssignment,
    initialCallRequest,
    acceptIncomingCall,
    endIncomingCall,
    endCall,
    aiAgentVoice,
    assignThreadStatus,
    getThreadTags,
    addThreadtags,
    updateThreadTags,
    deleteThreadTags,
    assignThreadTags,
    assignThreadNotes,
    getChatbotTriggerConfig,
    updateChatbotTriggerConfig,
    getApiKey,
    createApiKey,
    deleteApiKey,
    getRuleBasedInboxThreads,
    updateRuleBasedInboxThreadArchiveStatus,
    callCustomApiFromInbox,
    archiveTemplate,
    getWhatsAppPricing,
    getActionType,
    getChronoxUserRolesGeneric,
    getUserAssignmentRoles,
    createUserAssignmentRole,
    updateUserAssignmentRole,
    deleteUserAssignmentRole,
    getAPIRoutesPermissionAssignments,
    updateUserStatus,
    getCarouselTemplateGroups,
    deleteCarouselTemplateGroups,
    createCarouselTemplateGroups,
    updateCarouselTemplateGroups,
    getTicketStatusList,
    deleteTicketSubStatus,
    createTicketSubStatus,
    updateTicketSubStatus,
    getTicketField,
    createThreadTicket,
    updateThreadTicket,
    updateDirectSendCannedMsg,
    getTemplateLibraryUseCase,
    getTemplateLibraryCategory,
    getTemplateLibraryIndustry,
    getTemplateLibraryList,
    getTemplateLibraryDraftList,
    createDraftTemplate,
    deleteDraftTemplate,
    getAgentActivityMessageTypes,
    getAgentActivityMessageVariableType,
    enableDisableAgentActivityMsg,
    getPaymentConfigurations,
    syncMetaPaymentConfig,
    toggleSmbAgentAssignment,
    getEmojiList,
    getWebhookPayloadkey,
    getAILLMPlatform,

    getOrganizationTeamsList,
    getOrganizationTeamDetails,
    createOrganizationTeam,
    deleteOrganizationTeam,
    getCatalogProductOptionalFields,
    getWhatsAppCatalogs,
    getLeadOrders,
    updateLeadOrderStatus,
    updatePaymentStatus,
    syncCatalog,
    getAllIntegratedChannels,

    getInstagramCommentTrigger,
    createInstagramCommentTrigger,
    updateInstagramCommentTrigger,
    deleteInstagramCommentTrigger,

    getPricingPlans,
    getAddOns,
    subscribePlan,
    getSubscriptionStatus,
    getSubscriptionDetails,
    getTransactionStatus,
    purchaseAiCredits,
    
    getWabaApprovalStatus,
    submitWabaIntegrationRequest,
    updateAIChatbotKnowledgeBase,

    importRuleBasedChatbot,
};

export default agent;
